module.exports = __webpack_public_path__ + "img/JLB-min.11d68e2b.png";